export const EXPIRY_DAYS_RANGE_T_PLUS_NDAYS = 29; //which means the expiry range is today + next 29 days, total 30 days
export const MAX_PREVIOUS_MONTHS = 2;
export const MAX_FUTURE_MONTHS = 3;

export const DEFAULT_DATE_PLUS_N = 1; //Explanation: E.g. If n = 1, today is 2/6/2024, then the default date is 3/6/2024
